import {
    type SocialId,
    type SocialLinkData,
    SOCIAL_IDS,
} from '@beat-venues/common-types';

export const createSocialItems = (): SocialLinkData[] => {
    const socialItems: SocialLinkData[] = [];
    SOCIAL_IDS.forEach((social: SocialId) => {
        const href = import.meta.env[
            'VITE_PUBLIC_SOCIAL_' + social.toUpperCase()
        ];
        if (href) {
            socialItems.push({
                id: social,
                href: href,
            });
        }
    });
    return socialItems;
};
